import { AuthWebUrl } from './auth-url';
import { NoAuthWebUrl } from './no-atuh-url';
import { PublicWebUrl } from './public-url';

export const WebUrlData = {
  ...AuthWebUrl,
  ...NoAuthWebUrl,
  ...PublicWebUrl,
};
